import React from 'react';

const Contact = () => {
    return (
        <div className="container mx-auto px-4 py-10 max-w-4xl">
            <h1 className="text-4xl font-bold mb-8 text-center">İletişim</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-white shadow-lg rounded-lg p-8">
                    <h2 className="text-2xl font-bold mb-6">Bize Ulaşın</h2>
                    <form className="space-y-4">
                        <div>
                            <label className="block text-gray-700 mb-2 text-sm font-bold">Adınız Soyadınız</label>
                            <input type="text" className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black" placeholder="Adınız" />
                        </div>
                        <div>
                            <label className="block text-gray-700 mb-2 text-sm font-bold">E-posta Adresiniz</label>
                            <input type="email" className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black" placeholder="ornek@email.com" />
                        </div>
                        <div>
                            <label className="block text-gray-700 mb-2 text-sm font-bold">Mesajınız</label>
                            <textarea rows="4" className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black" placeholder="Mesajınızı buraya yazın..."></textarea>
                        </div>
                        <button type="submit" className="w-full bg-black text-white py-3 rounded hover:bg-gray-800 transition-colors">
                            Gönder
                        </button>
                    </form>
                </div>

                <div className="space-y-6">
                    <div className="bg-white shadow-lg rounded-lg p-8">
                        <h2 className="text-xl font-bold mb-4">İletişim Bilgileri</h2>
                        <div className="space-y-4 text-gray-700">
                            <p className="flex items-center">
                                <span className="material-icons mr-3 text-black">email</span>
                                info@kodutara.com
                            </p>
                        </div>
                    </div>

                    <div className="bg-gray-100 rounded-lg p-8 text-center">
                        <p className="text-gray-600">
                            Mesai saatleri içerisinde (09:00 - 18:00) bize ulaşabilirsiniz.
                            E-postalarınıza en geç 24 saat içinde dönüş yapılacaktır.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;